export const API_UNAUTHORIZED_EVENT = "syllarys:api-unauthorized";

export const authenticatedApiFetch: typeof fetch = async (input, init) => {
  const response = await fetch(input, init);
  if (response.status === 401) {
    window.dispatchEvent(new Event(API_UNAUTHORIZED_EVENT));
  }
  return response;
};
